import { capturePageview } from "@pontimed/analytics/client";
import { useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";

/**
 * Fires `$pageview` to PostHog on every TanStack Router location change in
 * the admin SPA. Sibling of the apps/app tracker — same contract, separate
 * mount point because the two apps have independent route trees.
 *
 * Most admin pageviews are filtered out at the SDK level via the
 * `data-ph-no-capture` selector list in
 * `packages/analytics/src/client/init.ts` so dashboards stay focused on
 * patient/provider behaviour rather than internal staff usage. The
 * meaningful events captured here are admin actions (provider approval,
 * data export, etc.) — wired per call site, not via this generic tracker.
 */
export function PostHogPageviewTracker() {
  const href = useRouterState({ select: (s) => s.location.href });

  useEffect(() => {
    if (!href) return;
    if (typeof window === "undefined") return;
    capturePageview(window.location.origin + href);
  }, [href]);

  return null;
}
